export const SET_JOURNAL = '[journals] setJournal';
export const RESET_JOURNAL = '[journals] resetJournal';
export const RESET_EDIT_JOURNAL = 'resetEditJournal';

export const FETCH_JOURNAL = {
  LOADING: 'fetchJournalLoading',
  SUCCESS: 'fetchJournalSuccess',
  FAIL: 'fetchJournalFail',
};

export const FETCH_MY_PUBLISHED_JOURNAL = {
  INIT: 'fetchMyPublishedJournalInit',
  LOADING: 'fetchMyPublishedJournalLoading',
  SUCCESS: 'fetchMyPublishedJournalSuccess',
  FAIL: 'fetchMyPublishedJournalFail',
  NEXT_LOADING: 'fetchNextMyPublishedJournalLoading',
  NEXT_SUCCESS: 'fetchNextMyPublishedJournalSuccess',
  NEXT_FAIL: 'fetchNextMyPublishedJournalFail',
};

export const FETCH_MY_DRAFT_JOURNAL = {
  INIT: 'fetchMyDraftJournalInit',
  LOADING: 'fetchMyDraftJournalLoading',
  SUCCESS: 'fetchMyDraftJournalSuccess',
  FAIL: 'fetchMyDraftJournalFail',
  NEXT_LOADING: 'fetchNextMyDraftJournalLoading',
  NEXT_SUCCESS: 'fetchNextMyDraftJournalSuccess',
  NEXT_FAIL: 'fetchNextMyDraftJournalFail',
};

export const DELETE_JOURNAL = {
  INIT: 'deleteJournalInit',
  LOADING: 'deleteJournalLoading',
  SUCCESS: 'deleteJournalSuccess',
  FAIL: 'deleteJournalFail',
};

export const CREATE_JOURNAL = {
  INIT: 'createJournalInit',
  LOADING: 'createJournalLoading',
  SUCCESS: 'createJournalSuccess',
  FAIL: 'createJournalFail',
};

export const UPDATE_JOURNAL = {
  INIT: 'updateJournalInit',
  LOADING: 'updateJournalLoading',
  SUCCESS: 'updateJournalSuccess',
  FAIL: 'updateJournalFail',
};

export const UPDATE_JOURNAL_POIS = {
  INIT: 'updateJournalPoisInit',
  LOADING: 'updateJournalPoisLoading',
  SUCCESS: 'updateJournalPoisSuccess',
  FAIL: 'updateJournalPoisFail',
};

export const UPLOAD_JOURNAL_COVER_TO_S3 = {
  LOADING: 'updateJournalCoverToS3Loading',
  SUCCESS: 'updateJournalCoverToS3Success',
  FAIL: 'updateJournalCoverToS3Fail',
};

export const UPDATE_JOURNAL_COVER = {
  INIT: 'updateJournalCoverInit',
  LOADING: 'updateJournalCoverLoading',
  SUCCESS: 'updateJournalCoverSuccess',
  FAIL: 'updateJournalCoverFail',
};

export const UPDATE_POI_PHOTO = {
  INIT: 'updatePoiPhotoInit',
  LOADING: 'updatePoiPhotoLoading',
  SUCCESS: 'updatePoiPhotoSuccess',
  FAIL: 'updatePoiPhotoFail',
};

export const UPLOAD_POI_PHOTO_TO_S3 = {
  LOADING: 'updatePoiPhotoToS3Loading',
  SUCCESS: 'updatePoiPhotoToS3Success',
  FAIL: 'updatePoiPhotoToS3Fail',
};

export const PUBLISH_JOURNAL = {
  LOADING: 'publishJournalLoading',
  SUCCESS: 'publishJournalSuccess',
  FAIL: 'publishJournalFail',
};
